import { Flex } from '@components';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flex: 1,
  height: '100%',
  maxHeight: '100%',
  overflowY: 'auto',
  flexDirection: 'column',
  padding: theme.spacing(0, 13),
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(20),
  },
}));

export const StyledHeaderContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  paddingTop: theme.spacing(12),
  marginBottom: theme.spacing(12),
  rowGap: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(8),
  },
}));
